import CityPageTemplate from "../city-template/CityPageTemplate";
import { morgantownConfig } from "./data";

export default function MorgantownPage() {
  return <CityPageTemplate config={morgantownConfig} />;
}